export default "__VITE_ASSET__0033cbe4__"